import { render } from "./MetricsTable.vue?vue&type=template&id=2cf13a4f&scoped=true"
import script from "./MetricsTable.vue?vue&type=script&lang=js"
export * from "./MetricsTable.vue?vue&type=script&lang=js"

import "./MetricsTable.vue?vue&type=style&index=0&id=2cf13a4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf13a4f"]])

export default __exports__